/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'share-modal.accordion-button-label':
    '{entity, select, project {Qui reçoit des mises à jour de projet hebdomadaires ?} goal {Qui reçoit les mises à jour hebdomadaires sur les objectifs ?} other {Qui reçoit les mises à jour hebdomadaires ?}}',
  'share-modal.add-as-follower-checkbox-label': 'Ajouter comme abonné',
  'share-modal.add-as-follower-checkbox-tooltip':
    '{entity, select, project {Les abonnés reçoivent une mise à jour projet hebdomadaire dans leur synthèse} goal {Les abonnés reçoivent une mise à jour objectif hebdomadaire dans leur synthèse} other {Les abonnés reçoivent une mise à jour hebdomadaire dans leur synthèse}}',
  'share-modal.all-tab-label': 'Tous',
  'share-modal.contributors-tab-label': 'Contributeurs',
  'share-modal.followers-tab-label': 'Abonnés',
  'share-modal.followers-title': 'Abonnés',
  'share-modal.footer.access-level-disclaimer':
    "{entity, select, project {Toutes les personnes ayant accès à l'espace de travail peuvent voir ce projet.} goal {Toutes les personnes ayant accès à l'espace de travail peuvent voir cet objectif.} other {Toutes les personnes ayant accès à l'espace de travail peuvent voir ceci.}}",
  'share-modal.footer.access-level-private-disclaimer':
    '{entity, select, project {Projet privé} goal {Objectif privé} other {}}',
  'share-modal.footer.copy-link-button': 'Copier le lien',
  'share-modal.footer.copy-link-button.copied-tooltip': 'Copiée !',
  'share-modal.footer.copy-link-button.tooltip':
    '{entity, select, project {Copier un lien vers un projet} goal {Copier un lien vers un objectif} other {Copier le lien }}',
  'share-modal.modal.user-picker.add-more-placeholder': 'Ajouter plus de personnes',
  'share-modal.share-button': 'Partager',
  'share-modal.share-title': 'Partager',
  'share-modal.user-item.can-edit-label': 'Peut modifier',
  'share-modal.user-picker.placeholder': 'Rechercher et inviter des personnes',
  'shareModal.followers-empty-state.default-title': 'Il manque des parties prenantes clés ?',
  'shareModal.followers-empty-state.goal-cta':
    "Assurez-vous que chaque contact reçoit les dernières mises à jour concernant votre objectif dans sa synthèse mensuelle en l'ajoutant comme abonné ou en connectant un canal Slack ou MS Teams.",
  'shareModal.followers-empty-state.project-cta':
    'Ajoutez des équipes et des parties prenantes clés comme abonnés pour les tenir au courant. Connectez un canal pour partager les mises à jour directement par chat.',
  'shareModal.followers-empty-state.project-title': 'Touchez un public plus large en ajoutant des abonnés',
};
